module.exports = __webpack_public_path__ + "img/flags.9c96e0ed.6eff2c9.png";